<template>
    <div class="model-el-group">
      <el-form ref="editor" inline label-width="90px">
        <el-form-item label="试题分类：">
          <el-select size="medium" v-model="form.nquestionCategory" clearable style="width:150px;" placeholder="请选择试题分类">
            <el-option :value="item.value" :label="item.label" v-for="(item, index) in QUESTIONS_TYPE.CLASSIFY" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题类型：">
          <el-select size="medium" v-model="form.nquestionType" :disabled="isDisabled" clearable style="width:150px;" placeholder="请选择题型">
              <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.TYPES" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题难度：">
          <el-select size="medium" v-model="form.nquestionLevel" clearable style="width:150px;" placeholder="请选择试题难度">
            <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.DIFFICULTY" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级产品：">
          <el-select size="medium" v-model="form.ntwoProductId" clearable style="width:150px;" filterable placeholder="请选择二级产品" @change="getThreeProductList(1)">
            <el-option :value="item.key" :label="item.value" v-for="(item, index) in secondProductList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="三级产品：">
          <el-select size="medium" v-model="form.nthreeProductId" clearable style="width:150px;" filterable placeholder="请选择三级产品" :loading="productLoading">
            <el-option :value="item.key" :label="item.value" v-for="(item, index) in threeProductList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌：">
          <el-select size="medium" v-model="form.sbrandId" clearable style="width:150px;" filterable placeholder="请选择品牌">
            <el-option :value="item.key" :label="item.value" v-for="(item, index) in brandList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题干：">
          <el-input 
            type="textarea" 
            :autosize="{minRows: 2}" 
            v-model="form.squestions" 
            style="width: 650px;" 
            placeholder="请输入题干"
          ></el-input>
        </el-form-item>
        <br>
        <el-form-item label="选项：">
          <div class="tips">{{form.nquestionType != 3?'单/多选的选项范围从2到6':'选择正确或者错误（默认正确）'}}</div>
          <!-- 单选 -->
          <template v-if="form.nquestionType == 1||!form.nquestionType">
            <el-radio-group v-model="radioOptions" v-if="soptionArr.length">
              <el-radio v-for="(item, index) in soptionArr" :key="index" :label="String.fromCharCode(index+65)">
                <!-- contenteditable="true" -->
                <div class="group">{{item.label}}<i class="el-icon-circle-close" @click.stop.prevent="deleteRow(index, soptionArr, String.fromCharCode(index+65))"></i></div>
              </el-radio>
            </el-radio-group>
          </template>
          <!-- 多选 -->
          <template v-if="form.nquestionType == 2">
            <el-checkbox-group v-model="checkOptionsArr" v-if="soptionArr.length">
              <el-checkbox v-for="(item, index) in soptionArr" :key="index" :label="String.fromCharCode(index+65)">
                <div class="group">{{item.label}}<i class="el-icon-circle-close" @click.stop.prevent="deleteRow(index, soptionArr, String.fromCharCode(index+65))"></i></div>
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <div class="textarea-editor" v-if="form.nquestionType != 3&&soptionArr.length<10">
            <el-input type="textarea" :autosize="{minRows: 2}" v-model="optionsText" style="width: 650px;" class="textarea" placeholder="请添加选项"></el-input>
            <el-button type="text" class="danger" @click="addSoptionClick">保存并新增</el-button>
          </div>
          <!-- 判断 -->
          <template v-if="form.nquestionType == 3">
            <el-radio-group v-model="judgeOptions">
              <el-radio label="A">
                <div class="is-test">正确</div>
              </el-radio>
              <el-radio label="B">
                <div class="is-test">错误</div>
              </el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-button type="primary" class="submit" @click="onSubmit">保 存</el-button>
      </el-form>
  </div>
</template>

<script>
import { TEST_TYPE, QUESTIONS_TYPE } from '@/config/const/common.js'
import { mapState } from 'vuex'
import { getThreeProductList } from '@/service/area'
import { getStorageUserRoleId } from '@/utils/store'
export default {
  data() {
    return {
      details: {},
      TEST_TYPE,
      QUESTIONS_TYPE,
      threeProductList: [],
      productLoading: false,
      form: {
        nquestionCategory: '',        //试题分类
        nquestionType: '',            //试题类型
        nquestionLevel:'',            //试题难度

        ntwoProductId: '',               //二级产品id
        nthreeProductId: '',             //三级产品id
        sbrandId: '',               //品牌id
        soption:'',
        squestions: '',             //题干（试题题目）
        srightAnswer: '',           //正确答案 'A'/'ABCDEFGHIJ'/'A|B'

        nquestionNo:'',             //编码
        pkid: '',                   
        userId: getStorageUserRoleId(),   //登录用户id
      },
      optionsText: '',              //选型textarea
      soptionArr:[],                //添加的选项
      
      isDisabled: false,            //是否可编辑试题类型

      radioOptions: '',             //单选
      checkOptionsArr: [],          //多选
      judgeOptions: 'A',            //判断
      oraginForm: {},
    }
  },
  created(){
    this.oraginForm = JSON.parse(JSON.stringify(this.form))
  },
  computed: {
    ...mapState({
      secondProductList: state => state.area.secondProductList,
      brandList: state => state.area.brandList
    })
  },
  methods: {
    setData(details) {
      this.details = details
      this.editorShow = true
      this.form.ntwoProductId = !details.ntwoProductId?'':details.ntwoProductId
      this.form.nthreeProductId = !details.nthreeProductId?'':details.nthreeProductId
      this.form.sbrandId = !details.sbrandId?'':details.sbrandId + ''
      this.form.nquestionLevel = details.nquestionLevel
      this.form.nquestionType = details.nquestionType
      this.form.nquestionCategory = details.nquestionCategory
      this.form.squestions = details.squestions
      this.form.nquestionNo = details.nquestionNo
      this.form.pkid = details.pkid
      this.form.srightAnswer = details.srightAnswer
      this.getThreeProductList(2);
      this.getSoptionArr();
      this.optionsText = ''
      this.isDisabled = details.isSelected? true: false
    },
    getSoptionArr() {
      let arr = []
      for (const key in this.details) {
        let ar = key.split('soption')
        if (!ar[0] && ar[1].length == 1 && this.details[key]) {
          arr.push({
            label: this.details[key]
          })
        }
      }
      this.soptionArr = arr
      if(this.details.nquestionType == 1){
        this.radioOptions = this.details.srightAnswer
      }else if(this.details.nquestionType == 2){
        this.checkOptionsArr = [...this.details.srightAnswer]
      }else{
        if(this.details.srightAnswer == '正确') {
          this.judgeOptions = 'A'
        }else if(this.details.srightAnswer == '错误'){
          this.judgeOptions = 'B'
        }else {
          this.judgeOptions = this.details.srightAnswer
        }
      }
    },
    // 获取三级产品
    async getThreeProductList(type){
      if(type == 1) {
        this.form.nthreeProductId = ''
      }
      this.productLoading = true
      let res = await getThreeProductList({ParentId:this.form.ntwoProductId})
      this.productLoading = false
      res.Result == 1 ? this.threeProductList=res.Data: [];
    },
    handleReset() {
      this.form = JSON.parse(JSON.stringify(this.oraginForm))
      this.optionsText = ''
      this.soptionArr = []
      this.radioOptions = '',
      this.checkOptionsArr = [],
      this.judgeOptions = 'A'
    },
    addSoptionClick(){
      if(!this.optionsText) {
        return this.$message.warning('请输入选项');
      }
      let optionsItem = {}
      optionsItem.label = this.optionsText;
      this.soptionArr.push(optionsItem)
      this.optionsText = ''
    },
    deleteRow(index, rows, dog) {
      if(this.form.nquestionType == 2) {
        this.checkOptionsArr = []
        // this.checkOptionsArr = this.checkOptionsArr.filter(t=>{
        //   return t != dog
        // })
      }else {
        if(dog == this.radioOptions) {
          this.radioOptions=''
        }
      }
      rows.splice(index, 1);
    },
    onSubmit(){
      let data = Object.assign({}, this.form);
      switch(data.nquestionType) {
        case 1:
          this.soptionArr.map((obj,index) =>{
            let en = String.fromCharCode(index+65)
            data['soption'+en] = obj.label
          })
          data.srightAnswer = this.radioOptions
          break;
        case 2:
          this.soptionArr.map((obj,index) =>{
            let en = String.fromCharCode(index+65)
            data['soption'+en] = obj.label
          })
          data.srightAnswer = this.checkOptionsArr.join('')
          break;
        default:
          data['soptionA'] = '正确'
          data['soptionB'] = '错误'
          data.srightAnswer = this.judgeOptions
      }
      !data.nquestionNo && delete data.nquestionNo;
      !data.pkid && delete data.pkid;
      if(!data.nquestionCategory) {
        return this.$message.warning('请选择试题分类');
      }
      if(!data.nquestionType) {
        return this.$message.warning('请选择试题类型');
      }
      if(data.nquestionLevel === '') {
        return this.$message.warning('请选择试题难度');
      }
      if(!data.ntwoProductId) {
        return this.$message.warning('请选择二级产品');
      }
      // if(!data.nthreeProductId) {
      //   return this.$message.warning('请选择三级产品');
      // }
      // if(!data.sbrandId) {
      //   return this.$message.warning('请选择品牌');
      // }
      if(!data.squestions) {
        return this.$message.warning('请输入题干');
      }
      if(data.nquestionType != 3) {
        if(this.soptionArr.length == 0) {
          return this.$message.warning('请添加选项');
        }
        if(this.soptionArr.length < 2) {
          return this.$message.warning('选项最少不能低于2项');
        }
        if(!data.srightAnswer){
          return this.$message.warning('请选择正确答案');
        }
      }
      delete data.soption;
      this.optionsText = ''
      this.$emit('onSubmit', data)
    },
  }
}
</script>

<style lang="scss">
.cus-msg-title {
  margin-left: 20px;
}
.tips {
  font-size: 12px;
  color: #999999;
  line-height: 40px;
  margin-bottom: 20px;
}
.model-el-group {
  .el-radio,.el-checkbox {
    display: block;
    margin-right: 0;
    margin-bottom: 20px;
  }
}
.group {
  height: 34px;
  border: 1px solid #DCDFE6;
  font-size: 14px;
  color: #999999;
  line-height: 34px;
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px 0 10px;
  width: 604px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  white-space:nowrap;
  text-overflow: ellipsis;
  i {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 36px;
    height: 34px;
    z-index: 2;
    cursor: pointer;
    font-size: 24px;
    text-align: center;
    line-height: 34px;
    // display: none;
    opacity: 0;
    transition: all 0.4s;
  }
}
.group:hover {
  width: 582px;
  padding: 0 32px 0 10px;
  i {
    opacity: 1;
    // display: block;
  }
}
.group i:hover {
  color: #f78989;
}
.textarea-editor {
  position: relative;
  margin-bottom: 30px;
  width: 650px;
  .textarea .el-textarea__inner {
    padding-bottom: 30px;
    min-height: 60px;
  }
  .danger {
    position: absolute;
    right: 10px;
    bottom: 0;
    margin: 10px;
    padding: 0;
  }
}
.danger {
  color: #f56c6c;
}
.danger:focus,.danger:hover {
  color: #f78989;
}
.is-test {
  display: inline-block;
  vertical-align: middle;
}
  .submit {
    display: block;
    margin: 30px auto 40px;
    min-width: 100px;
  }
</style>